import React, { Fragment, memo } from 'react';
import isEqual from 'react-fast-compare';
import { omit } from 'lodash';
import Panel from '../../../../../../components/outline/Panel';
import Table from '../../../../../../components/_table/Table';
import Button from '../../../../../../components/Button';
import DateRangePicker from '../../../../../../components/datePicker/DateRangePicker';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import {
  PLACEHOLDER_TEXT_WIDGET_EXPOSURE_PERIOD_DATE,
  WIDGET_EXPOSURE_TYPE,
} from '../../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';
import './HomeWidgetList.scss';

const HomeWidgetList = memo(
  (props) => {
    const {
      pageWidgetList,
      setData,
      getList,
      saveWidgetList,
      homeType,
      onChangeBulkWidgetPeriod,
      onChangeWidgetStatus,
      onChangeWidgetNo,
      getWidgetPreviewData,
      widgetPreviewCompare,
      getInactiveWidgetList,
    } = props;
    const { widgetExposurePeriodBatchInfo, widgetList, selectedWidgetIdList, originalWidgetList } = pageWidgetList;
    const { list } = widgetList;

    /**
     *  위젯 변경 사항 체크
     */
    const isUpdateList = !isEqual(
      list.map((item) => omit(item, 'isEdit')),
      originalWidgetList,
    );

    return (
      <div className="home-widget-list">
        <Panel>
          <div className="panel-header">
            <div className="title">위젯 리스트</div>
            <div className="btn-area">
              <Button color="primary" text="위젯 미리보기" onClick={() => widgetPreviewCompare()} />

              {
                /**
                 *  노출 중인 위젯 리스트가 변경이 있을 때만 초기화, 저장 버튼을 노출한다
                 */
                isUpdateList ? (
                  <Fragment>
                    <Button text="초기화" onClick={getList} />
                    <Button text="저장" color="primary" onClick={saveWidgetList} />
                  </Fragment>
                ) : null
              }
            </div>
          </div>

          <div className="panel-body">
            <div className="page-widget-btn-area">
              <div className="button-form">
                <div className="label">노출기간 일괄변경</div>

                <div className="button-list">
                  <DateRangePicker
                    value={widgetExposurePeriodBatchInfo}
                    showTime={true}
                    startText={PLACEHOLDER_TEXT_WIDGET_EXPOSURE_PERIOD_DATE}
                    endText={PLACEHOLDER_TEXT_WIDGET_EXPOSURE_PERIOD_DATE}
                    outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
                    btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
                    format={DATE_FORMAT.FULL_DASH_FORMAT}
                    onSelect={(date) =>
                      setData({
                        path: ['pageWidgetList', 'widgetExposurePeriodBatchInfo'],
                        value: date,
                      })
                    }
                  />

                  <div className="apply-button-list">
                    <Button
                      color="primary"
                      onClick={() => onChangeBulkWidgetPeriod(WIDGET_EXPOSURE_TYPE.DIRECT_SETTING)}
                      text="기간 적용"
                    />

                    <Button
                      color="light"
                      onClick={() => onChangeBulkWidgetPeriod(WIDGET_EXPOSURE_TYPE.INFINITE)}
                      text="무기한 설정"
                    />
                  </div>

                  <Button color="primary" onClick={() => getInactiveWidgetList()} text="비활성 위젯 추가" />
                </div>
              </div>
            </div>

            <div className="help-text">위젯을 드래그 앤 드랍을 이용해서 순서를 변경 할 수 있습니다.</div>
            <div className="help-text">노출중인 위젯 리스트의 변경이 있을 경우, 회색으로 음영처리가 됩니다.</div>

            <Table
              columns={(utils) =>
                columns({
                  onChangeWidgetStatus,
                  getWidgetPreviewData,
                  homeType,
                  ...utils,
                })
              }
              rowKey={(record) => record.id}
              list={list}
              size="small"
              scroll={{ x: true }}
              bordered={true}
              canDrag={true}
              rowClassName={(record) => (record.isEdit ? 'is-edit' : '') || (record.isHomeMenu ? 'row-not-drag' : '')}
              onCheck={(list) =>
                setData({
                  path: ['pageWidgetList', 'selectedWidgetIdList'],
                  value: list,
                })
              }
              showPagination={false}
              selectedList={selectedWidgetIdList}
              onDragEnd={(data) => onChangeWidgetNo(data.list)}
            />
          </div>
        </Panel>
      </div>
    );
  },
  (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps),
);

HomeWidgetList.displayName = 'HomeWidgetList';

export default HomeWidgetList;
